import { cronosClient } from "@/config/client"

interface Params {
  eventId: string
  isBulkDelete: boolean
}

export function remove(params: Params) {
  const { eventId, isBulkDelete } = params
  return cronosClient.del(`/v1/user/events/${eventId}`, { params: { isBulkDelete } })
}
